//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONT
import { TITLE_SIZE, SUB_TITLE_SIZE, TEXT_SIZE } from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import BannerSection from "../../components/BannerSection";
import FooterBar from "../../components/FooterBar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FAQ from "../../components/FAQ";
import { MdLockOutline } from "react-icons/md";
import { TbUserShield } from "react-icons/tb";
import { IoIosLink } from "react-icons/io";
import { PiCookie } from "react-icons/pi";
import PrivacidadeBG from "../../assets/images/privacidade.webp";
import "./Privacidade.css";

export default function Privacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const privacyQuestions = [
    {
      id: 0,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>1. Introdução.</p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Aviso de Privacidade é o documento por meio do qual o Grupo Krause
            explica aos titulares de dados e demais interessados as práticas e
            procedimentos adotados para tornar transparente a relação de
            privacidade e proteção de dados pessoais. Basicamente, o Grupo
            Krause informa aos titulares de dados pessoais sobre os direitos,
            garantias e procedimentos adotados em relação ao tratamento das
            informações pessoais em seus projetos, produtos, serviços e/ou
            processos operacionais.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Este Aviso de Privacidade está em conformidade com os requisitos da
            Lei n° 13.709/2018, mais conhecida como Lei Geral de Proteção de
            Dados (LGPD) e tem por finalidade esclarecer aos interessados acerca
            das medidas que são adotadas para proteger e respeitar a privacidade
            de dados dos indivíduos, informando os procedimentos de como o
            titular poderá executar o exercício dos seus direitos junto ao Grupo
            Krause.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Este Aviso de Privacidade poderá ser atualizado em decorrência de
            eventual atualização normativa e mudanças de procedimentos, razão
            pela qual se convida o titular dos dados a consultar periodicamente
            este documento.
          </p>
        </div>
      ),
    },
    {
      id: 1,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          2. Quais são as principais definições?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>LGPD:</span> Lei Geral de Proteção de Dados (L. 13.709/18)
            http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Dado Pessoal:</span> A Lei Geral de Proteção de Dados - LGPD,
            define em seu artigo 5º, inciso I, que dado pessoal é todo aquele
            dado que se refira a uma pessoa natural identificada ou
            identificável. Essa definição compreende todo aquele dado que
            permite identificar uma pessoa física diretamente ou a combinação de
            dados que podem identificar um determinado titular de dados de forma
            inequívoca.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Dados Pessoal Sensível:</span> É o dado pessoal sobre origem
            racial ou étnica, convicção religiosa, opinião política, filiação a
            sindicato ou a organização de caráter religioso, filosófico ou
            político, dado referente à saúde ou à vida sexual, dado genético ou
            biométrico, quando vinculado a uma pessoa natural.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Titular:</span> O titular dos dados é a pessoa natural na qual
            se referem os dados pessoais que são objeto do tratamento, ou seja,
            quem possui a titularidade da informação.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Controlador:</span> É a pessoa natural ou jurídica, de direito
            público ou privado, dentre a qual competem decisões sobre como o
            tratamento dos dados pessoais é realizado.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Operador:</span> É a pessoa natural ou jurídica, de direito
            público ou privado que realiza o tratamento em nome do controlador.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Encarregado/DPO:</span> É a pessoa que atua na organização
            como um canal de ligação e comunicação, entre o controlador, os
            titulares de dados, e a Agência Nacional de Proteção de Dados
            (ANPD).
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>ANPD:</span> Agência Nacional de Proteção de Dados é o órgão
            da administração pública responsável por zelar, implementar e
            fiscalizar o cumprimento desta Lei em todo o território nacional.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          3. Quais são os direitos do titular de dados?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            A LGPD garante aos titulares de dados uma série de direitos, os
            quais o respeita integralmente, conforme previsto no Artigo 18 da
            legislação. Esses direitos incluem:
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Direito de acesso (Art.18, II):</span> É o direito do titular
            dos dados de ter acesso aos dados que estão sendo tratados pela
            organização;
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Direito de retificação (Art.18, III):</span> O titular dos
            dados pode solicitar ao controlador a correção de dados incompletos,
            inexatos ou desatualizados;
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Direito à eliminação dos dados (Art.18, IV):</span> Diz
            respeito à possibilidade de ter seus dados apagados da base de dados
            do controlador;
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>
              Direito à limitação do tratamento dos dados (Art.18, V):
            </span>{" "}
            É o direito do titular de limitar o tratamento de seus dados
            pessoais, podendo obtê-la quando contesta a exatidão dos dados,
            quando o tratamento for ilícito, quando o controlador não precisar
            mais dos dados para as finalidades propostas e quando tiver se
            oposto ao tratamento dos dados e em caso de tratamento de dados
            desnecessários;
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Direito de oposição (Art.18, VI):</span> Versa sobre a
            possibilidade do titular dos dados, a qualquer momento, se opor por
            motivos relacionados com a sua situação particular, ao tratamento de
            dados pessoais que lhe digam respeito, podendo se opor, ainda, ao
            uso de seus dados pessoais para definição de perfil de marketing;
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Direito à portabilidade dos dados (Art.18, VII):</span> É o
            direito do titular de solicitar ao controlador que envie seus dados
            a outro fornecedor de serviço ou produto, mediante requisição
            expressa, de acordo com a regulamentação da ANPD, observados os
            segredos comercial e industrial.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>
              Direito de não ser submetido a decisões automatizadas (Art.18,
              VIII):
            </span>{" "}
            É o direito do titular de não ficar sujeito a nenhuma decisão tomada
            exclusivamente com base no tratamento automatizado, incluindo a
            definição de perfis, que produza efeitos na sua esfera jurídica ou
            que o afete significativamente de forma similar.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O titular dos dados poderá exercer seus direitos enviando uma
            comunicação escrita ao controlador, especificando quais direitos
            deseja exercer. O pedido deverá ser encaminhado para o e-mail do
            Encarregado de Dados do Grupo Krause, no endereço eletrônico:
            dpo@grupokrausecom.br.
            <br />
            As solicitações serão respondidas no prazo máximo de 15 (quinze)
            dias a partir da data do requerimento, conforme o Art. 19 da LGPD.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          4. Quais são os princípios relativos ao tratamento de dados?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Grupo Krause se compromete a cumprir as determinações previstas na
            LGPD, em respeito aos seguintes princípios dispostos no Artigo 6° da
            referida lei:
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Finalidade: </span>Os dados pessoais do titular
            serão para propósitos legítimos, específicos, explícitos e
            informados ao titular, sem possibilidade de tratamento posterior de
            forma incompatível com essas finalidades.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Adequação:</span> Os dados pessoais do titular
            serão tratados de forma adequada às finalidades informadas ao
            titular, de acordo com o contexto de tratamento.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Necessidade:</span> Os dados pessoais do titular
            serão tratados de forma pertinente e limitada às necessidades do
            objetivo para os quais eles são processados.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio do Livre Acesso:</span> Os dados pessoais do titular
            serão tratados e garantidos, aos titulares, consulta facilitada e
            gratuita sobre a forma e duração de tratamento, bem como sobre a
            integralidade dos seus dados.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Qualidade dos Dados:</span> Os dados pessoais do
            titular serão exatos e atualizados sempre que necessário, de maneira
            que dados inexatos sejam apagados ou retificados quando possível.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Transparência:</span> Os dados pessoais dos
            titulares serão tratados e garantidos, aos titulares, informações
            claras, precisas e facilmente acessíveis, inclusive sobre os agentes
            de tratamento, ressalvados os segredos comercial e industrial.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Segurança:</span> Os dados pessoais do titular
            serão tratados de forma segura, protegidos do tratamento não
            autorizado ou ilícito e contra a sua perda, destruição ou
            danificação acidental, adotando as medidas técnicas ou organizativas
            adequadas.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Prevenção:</span> Os dados pessoais do titular
            serão tratados, utilizando-se, o controlador, de todas as medidas
            para prevenir a ocorrência de danos em virtude desse tratamento.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Não Discriminação:</span> Os dados pessoais do
            titular NÃO serão tratados para fins discriminatórios, ilícitos ou
            abusivos.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Princípio da Responsabilização e Prestação de Contas:</span>{" "}
            Os dados pessoais do titular serão tratados, pelo controlador, de
            forma capaz de demonstrar as medidas adotadas a fim de comprovar a
            observância e o cumprimento das normas pertinentes à proteção de
            dados.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Todo tratamento de dados pessoais realizado pelo Grupo Krause tem
            como objetivo respeitar os princípios acima citados.
          </p>
        </div>
      ),
    },
    {
      id: 4,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          5. Quais são os dados pessoais tratados pelo Grupo Krause?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Grupo Krause trata dados pessoais de quem é ou foi cliente, usuário,
            de quem teve algum tipo de relacionamento com a empresa como por
            exemplo: colaborador, empregado, ex-empregados, sócio de algum
            cliente, empresa ou entidade com a qual o Grupo Krause se relaciona
            ou pretende se relacionar. Os dados pessoais tratados podem variar
            conforme as finalidades, incluindo aquelas mencionadas neste Aviso
            de Privacidade, bem como de acordo com as atividades executadas pelo
            Grupo Krause. O Grupo Krause, em suas operações padrão, não realiza
            o tratamento de dados de crianças ou adolescentes. No entanto, caso
            isso ocorra, será em caráter excepcional e somente com a devida base
            legal, em conformidade com a LGPD.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Grupo Krause trata dados pessoais sensíveis em estrita
            conformidade com o Art. 11 da LGPD. Isso significa que o tratamento
            desses dados ocorre apenas com o consentimento do titular ou, na
            ausência deste, quando o tratamento for essencial para o cumprimento
            de uma obrigação legal ou regulatória pelo controlador; para o
            exercício regular de direitos, incluindo contratos e processos
            judiciais, administrativos ou arbitrais; ou para garantir a
            prevenção à fraude e a segurança do titular em processos de
            identificação e autenticação de cadastro em sistemas eletrônicos. Em
            todos os casos, os direitos previstos na LGPD são resguardados.
          </p>
        </div>
      ),
    },
    {
      id: 5,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          6. Bases legais para tratamento dos dados pessoais.
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            A LGPD exige que o tratamento de dados pessoais esteja enquadrado em
            ao menos uma base legal. No Grupo Krause, as bases legais são as
            seguintes:
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              O Consentimento do titular dos dados;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Cumprimento de obrigação legal ou regulatória pelo controlador;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Execução de contrato ou de procedimentos preliminares relacionados
              a contrato do qual seja parte o titular, a pedido do titular dos
              dados;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Exercício regular de direitos em processo judicial, administrativo
              ou arbitral, esse último nos termos da Lei nº 9.307, de 23 de
              setembro de 1996 (Lei de Arbitragem);
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Proteção da vida ou da incolumidade física do titular ou de
              terceiro;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Legítimo Interesse do controlador ou de terceiro;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Proteção ao Crédito;
            </span>
          </p>
          <p>
            <span style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Para garantir a prevenção à fraude e a segurança do titular em
              processos de identificação e autenticação de cadastro em sistemas
              eletrônicos.
            </span>
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Todos os processos operacionais que realizam tratamento de dados
            pessoais do Grupo Krause atendem, ao menos, uma das bases legais de
            tratamento dos dados.
          </p>
        </div>
      ),
    },
    {
      id: 6,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          7. Segurança relativa ao tratamento de dados pessoais.
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Grupo Krause se compromete a aplicar todas as medidas técnicas e
            organizacionais aptas a proteger os dados pessoais tratados de
            acessos não autorizados e de situações de destruição, perda,
            alteração, comunicação ou difusão de tais dados. Para a garantia da
            segurança, serão adotadas soluções que levem em consideração as
            técnicas adequadas, os custos de aplicação, a natureza, o âmbito, o
            contexto e as finalidades do tratamento e os riscos para os direitos
            e liberdades do titular.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            No entanto, o Grupo Krause isenta-se de responsabilidade em casos de
            culpa exclusiva de terceiros ou do próprio titular, conforme
            estabelecido pela LGPD. O Grupo Krause também se compromete a
            notificar o titular, conforme estabelecido pela lei, caso ocorra
            qualquer violação de segurança dos seus dados pessoais que possa
            gerar risco ou dano significativo aos seus direitos e liberdades. A
            violação de dados pessoais é uma violação de segurança que provoque,
            de modo acidental ou ilícito, a destruição, a perda, a divulgação ou
            o acesso não autorizado a dados pessoais transmitidos, conservados
            ou sujeitos a qualquer outro tipo de tratamento. Os dados pessoais
            armazenados são tratados garantindo a confidencialidade, a
            integridade e a disponibilidade das informações, dentro dos limites
            legais.
          </p>
        </div>
      ),
    },
    {
      id: 7,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          8. Transferência internacional de dados.
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Grupo Krause realiza a transferência internacional e o tratamento
            transfronteiriço de dados pessoais em estrita observância ao
            disposto no{" "}
            <b>
              artigo 33 da Lei Geral de Proteção de Dados Pessoais (LGPD) e à
              Resolução CD/ANPD nº 19, de 23 de agosto de 2024.
            </b>{" "}
            Dessa forma, os dados podem ser tratados tanto em território
            nacional quanto em países que possuam legislações de proteção de
            dados pessoais reconhecidamente adequadas ou equivalentes às
            brasileiras. Para assegurar a conformidade e a proteção dos
            titulares, o Grupo Krause adota cláusulas contratuais e medidas
            específicas compatíveis com as normas brasileiras aplicáveis.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Essa resolução estabelece requisitos para a transferência
            internacional de dados, garantindo que qualquer transferência para
            fora do Brasil ocorra em conformidade com padrões de proteção
            adequados, respeitando os direitos e liberdades fundamentais dos
            titulares dos dados. Quando o Grupo Krause realiza o tratamento
            transfronteiriço de dados, toma todas as medidas necessárias para
            garantir que os direitos dos titulares sejam respeitados e que as
            transferências sejam feitas apenas para países ou organizações que
            proporcionem um nível de proteção de dados adequado, conforme
            exigido pela legislação brasileira e pela Resolução nº 19 da ANPD.
          </p>
        </div>
      ),
    },
    {
      id: 8,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          9. Do Controlador de dados.
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          O controlador de dados pessoais, é a pessoa física ou jurídica, a
          autoridade pública ou qualquer outro organismo que, individualmente ou
          em conjunto com outros, determina as finalidades e os meios de
          tratamento desses dados. No presente caso, o Grupo Krause é o
          controlador de dados pessoais, e pode ser contatado por meio dos
          canais de comunicação disponíveis.
        </p>
      ),
    },
    {
      id: 9,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          10. Do Encarregado de proteção de dados (Data Protection Officer -
          DPO).
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          O Encarregado de Proteção de Dados (Data Protection Officer – DPO) é a
          pessoa designada pelo controlador para atuar como canal de comunicação
          entre o controlador, os titulares dos dados e a Agência Nacional de
          Proteção de Dados (ANPD), conforme estabelecido na legislação vigente
          e determinado pela Resolução CD/ANPD nº 18, de 16 de julho de 2024.
          Essa designação atende ao disposto no artigo 41 da Lei Geral de
          Proteção de Dados Pessoais (Lei nº 13.709/2018) e às diretrizes
          estabelecidas pela Resolução CD/ANPD nº 18, de 16 de julho de 2024. No
          caso do Grupo Krause, o Encarregado de Proteção de Dados (DPO) é
          DeServ Segurança da Informação, na figura de Bruna Fabiane da Silva,
          bem como DeServ Segurança da Informação, na figura de Ana Vitória
          Germani D’Avila, para o cargo de DPO substituto, que poderão ser
          contatados através do seguinte endereço de e-mail:
          dpo@grupokrause.com.br.
        </p>
      ),
    },
    {
      id: 10,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          11. Das alterações para esse aviso de privacidade.
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Este Aviso de Privacidade foi atualizado pela última vez em
          23/03/2026. O Grupo Krause se reserva o direito de modificar este
          Aviso de Privacidade a qualquer momento. Portanto, é recomendável que
          o titular o revise periodicamente. As alterações e esclarecimentos
          terão efeito imediato após sua publicação no site da empresa.
        </p>
      ),
    },
    {
      id: 11,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          12. Informações de contato.
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            O Grupo Krause também está disponível através dos contatos abaixo:
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>Controlador: contato@grupokrause.com.br</span>
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>DPO/Encarregado dos Dados: dpo@grupokrause.com.br</span>
          </p>
        </div>
      ),
    },
  ];

  const cookiesQuestions = [
    {
      id: 0,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>1. Introdução</p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            A Política de Cookies utilizada pelo Grupo Krause e abaixo descrita,
            tem como finalidade descrever as práticas por nós seguidas para
            respeitar a privacidade de todos os visitantes do nosso site.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            A legislação brasileira, LGPD, define, em seu artigo 5º, inciso I, o
            que é dado pessoal como todo aquele que se refira a uma pessoa
            natural identificada ou identificável. Na prática, a expressão
            compreende todo aquele dado que permite identificar uma pessoa
            diretamente ou a combinação de dados que podem identificar o titular
            de forma inequívoca.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            A utilização de cookies pelo nosso site, tem como objetivo melhorar
            o desempenho e lhe apresentar uma navegação mais personalizada, pois
            esses cookies nos permitem entender um pouco mais sobre nossos
            usuários.
          </p>
        </div>
      ),
    },
    {
      id: 1,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          2. O que é um cookie?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Um cookie é uma tecnologia que nosso site solicita ao seu navegador
            para armazenar no seu computador ou outro dispositivo móvel, com
            objetivo de armazenar tokens de informação (identificador). Esse
            identificador é usado pelo site do Grupo Krause. A utilização dos
            cookies permite que o nosso site “lembre” das suas ações e
            preferências ao longo do tempo. Importante destacar que os cookies
            não são usados para determinar a identidade pessoal de quem está
            visitando nosso site. Esses cookies são definidos por nós e chamados
            de cookies de primeira parte.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Em determinadas páginas do nosso site, os cookies são usados para
            nos ajudar a rastrear seus interesses enquanto você navega na
            Internet, para que possamos personalizar mais anúncios relevantes e
            entender o que é importante para você. Também usamos cookies de
            terceiros - que são cookies de um domínio diferente do domínio do
            nosso site - para nossos esforços de publicidade e marketing. A
            maioria dos navegadores da Internet aceitam cookies; entretanto, os
            usuários podem configurar seus navegadores para recusar certos tipos
            de cookies ou cookies específicos. Além disso, os usuários podem
            apagar os cookies a qualquer momento.
          </p>
        </div>
      ),
    },
    {
      id: 2,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          3. Por que usamos cookies?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Usamos cookies para entender melhor o perfil dos nossos usuários e
            garantir uma melhor experiência ao visitar nosso site.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Alguns cookies, por exemplo, têm como objetivo lembrar o idioma de
            sua preferência, para que o nosso usuário não precise efetuar essa
            escolha a cada nova visita. Outro tipo de cookie utilizado por nós,
            é para ajudar no rastreamento de geolocalização. Além disso, os
            cookies permitem que ofereçamos um conteúdo específico, tais como
            vídeos no nosso website. Podemos empregar o que aprendemos sobre o
            seu comportamento no nosso website para oferecer anúncios
            direcionados em websites de terceiros em um esforço para
            “reapresentar” nossos produtos e serviços para você.
          </p>
        </div>
      ),
    },
    {
      id: 3,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          4. Quais os tipos de cookies que utilizamos?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Cookies necessários: Eles estabelecem o mínimo necessário para poder
          abrir a nossa página eser possível navegar e acessar as
          funcionalidades básicas do nosso site.
        </p>
      ),
    },
    {
      id: 4,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          5. Como os cookies são usados para o propósito de anúncios?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Cookies e tecnologias de anúncios tais como ‘web beacons’, ‘pixels’
            e ‘tags’ de redes de anúncios nos ajudam a oferecer anúncios
            relevantes de forma mais eficaz. Eles também nos ajudam a coletar
            dados consolidados para fins de auditorias, pesquisas e relatórios
            de desempenho. Os pixels permitem que compreendamos e possamos
            melhorar a oferta de anúncios para você, e permitem ainda saber
            quando determinados anúncios já foram apresentados a você. Como o
            seu navegador pode requisitar anúncios e ‘web beacons’ diretamente
            de servidores de rede de anúncios, estas redes podem visualizar,
            editar ou configurar seus próprios cookies, como se você tivesse
            acessado uma página web do site deles.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Embora nós não utilizemos cookies para criar um perfil do seu
            comportamento de navegação em sites de terceiros, nós utilizamos
            informações consolidadas de tais terceiros para mostrar a você
            anúncios relevantes, com base nos seus interesses.
          </p>
        </div>
      ),
    },
    {
      id: 5,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          6. Como os cookies de terceiros são usados?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          Para algumas das funções dentro dos nossos websites usamos
          fornecedores terceirizados. Estes vídeos ou links (e qualquer outro
          conteúdo de fornecedores terceirizados) podem conter cookies de
          terceiros, e nós recomendamos consultar as políticas de privacidade
          destes terceiros nos seus websites para informações relativas à sua
          utilização de cookies.
        </p>
      ),
    },
    {
      id: 6,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          7. Como rejeitar ou apagar os cookies?
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Você pode escolher rejeitar ou bloquear todos ou tipos específicos
            de cookies configurados através da sua visita ao website do Grupo
            Krause ao clicar nas preferências de cookies no nosso website. Você
            pode modificar as suas preferências para website do Grupo Krause
            e/ou os websites de terceiros alterando as configurações do seu
            navegador. Pedimos para observar que a maioria dos navegadores
            aceitam cookies automaticamente. Portanto, se você não quiser que
            cookies sejam utilizados, você talvez tenha que apagar ou bloquear
            cookies ativamente.
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Se você rejeitar a utilização de cookies, você poderá visitar o
            nosso website, mas algumas das funções poderão não funcionar
            corretamente. Ao utilizar o nosso website sem apagar ou rejeitar,
            você concorda que podemos posicionar aqueles cookies que você não
            apagou ou rejeitou nos seus dispositivos.
          </p>
        </div>
      ),
    },
    {
      id: 7,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          8. Alteração da política de cookies?
        </p>
      ),
      answer: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          O Grupo Krause se dá ao direito de alterar esta declaração de Política
          de Cookies sempre que entender necessário, por isso convidamos você a
          visitar nossas políticas frequentemente.
        </p>
      ),
    },
    {
      id: 8,
      title: (
        <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
          9. Informações de contato
        </p>
      ),
      answer: (
        <div>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Se persistirem dúvidas sobre a nossa Política de Cookies, estamos
            disponíveis através dos contatos abaixo:
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>
              Controlador: 51 3036 9660 | 51 9414 1188 | 0800 002 9600
            </span>
          </p>
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            <span>DPO/Encarregado dos Dados: dpo@grupokrause.com.br</span>
          </p>
        </div>
      ),
    },
  ];

  return (
    <div>
      <DynamicTitle
        pageTitle="Grupo Krause"
        pageMeta="Grupo Krause"
        pageContent="Valorizando a vida com serviços que respeitam o ser humano. Grupo Krause é formado por quatro marcas que oferecem serviços funerários no RS."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <MdLockOutline
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"PRIVACIDADE"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Acesse o nosso Aviso de Privacidade, a LGPD na íntegra e nossa política de cookies"
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={PrivacidadeBG}
        bannerBGmobile={PrivacidadeBG}
      />
      <Container>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              O Grupo Krause é formado pelas seguintes empresas:
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              <span>Krause Planos Assistenciais Ltda</span>, inscrita no CNPJ
              sob o n.º 25.447.487/0001-86, com sede na Cidade de Novo Hamburgo,
              Estado do Rio Grande do Sul, na Rua Júlio de Castilhos, n.º 342,
              Bairro Centro.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              <span>Assiste Bem Planos e Seguros Ltda</span>, inscrita no CNPJ
              sob n.º 10.284.571/0001-59, com sede na Cidade de Novo Hamburgo,
              Estado do Rio Grande do Sul, na Rua Júlio de Castilhos, n.º 348,
              Bairro Centro.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              <span>Funerária Krause Ltda</span>, inscrita no CNPJ sob n.º
              91.677.468/0001-70, com sede na Cidade de Novo Hamburgo, Estado do
              Rio Grande do Sul, na Rua Santos Pedroso, n.º 155, Bairro Hamburgo
              Velho.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              <span>Funerária Franceschetti Ltda</span>, inscrita no CNPJ sob
              n.º 02.594.538/0001-05, com sede na Cidade de Campo Bom, Estado do
              Rio Grande do Sul, na Av. Presidente Vargas, n.º 131, Bairro
              Centro.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              <span>Memorial Krause - Funerária Krause Ltda (Filial 7)</span>,
              inscrita no CNPJ sob n.º 91.677.468/0007-66, com sede na Cidade de
              Novo Hamburgo, Estado do Rio Grande do Sul, na Rua Helmuth Heldt,
              120, Bairro Canudos.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="privacy-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Inclui-se no Rol acima todas as suas filiais.
            </p>
          </Col>
        </Row>
      </Container>
      <FAQ
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        iconTitle={
          <TbUserShield style={{ color: ICON_COLOR_GK }} className="faq-icon" />
        }
        titleContent="AVISO DE PRIVACIDADE"
        questionsContent={privacyQuestions}
      />
      <Container>
        <Row>
          <Col className="privacy-second-col">
            <a
              href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
              rel="noopener noreferrer"
              target="_blank"
              style={{ color: TITLE_COLOR_GK, fontSize: TEXT_SIZE }}
            >
              <IoIosLink className="privacy-icon" />
              Lei 13.709/2018 – Lei Geral de Proteção de Dados Pessoais
            </a>
          </Col>
        </Row>
      </Container>
      <FAQ
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        iconTitle={
          <PiCookie style={{ color: ICON_COLOR_GK }} className="faq-icon" />
        }
        titleContent="POLÍTICA DE COOKIES"
        questionsContent={cookiesQuestions}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
